//@flow
import generalActions from './generalActions';
import type {general} from "../../services/flowTypes/dataFlowTypes";
import type {action} from "../../services/flowTypes/appFlowTypes";

type reducerAction = action;

const initialState = {
  organizationsList: null,
  // rolesList: null
};

const generalReducer = (state:general = initialState, action:reducerAction) => {
  switch (action.type) {
    case generalActions.GENERAL_STATE_PROP_SET:
      return {
        ...state,
        [action.value.prop]: action.value.data
      }
    default:
      return state;
  }
};

export default generalReducer;